import React, { useState } from 'react'
 
import SalesBeatPlanList from './SalesBeatPlanList';
import SalesBeatPlanForm from './SalesBeatPlanForm';

const SalesBeatPlan= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <SalesBeatPlanForm addForm={setFromIsShown} update={upData} />
        ) : (
          <SalesBeatPlanList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default SalesBeatPlan